import { Button, styled, Tooltip } from '@mui/material'
import { memo } from 'react'
import { useOrderbook } from 'store/orderbook/hooks'
import { Ether } from 'types'

export const StyledLastPriceButton = styled(Button)`
  height: 24px;
  padding: 0;
  font-weight: 400;
  padding: 0 8px;
  font-size: 14px;
  margin-right: 8px;
  color: ${({ theme }) => theme.color.text100};
  border: 1px solid rgba(46, 54, 59, 1);
  border-radius: 12px;
  &:hover {
    color: rgba(160, 238, 9, 1);
    background-color: transparent;
    border-color: rgba(160, 238, 9, 1);
  }
`

export const LastPriceButton = memo<{
  onHandleClick: (price: Ether) => void
}>(({ onHandleClick }) => {
  const { price = '' } = useOrderbook()
  return (
    <StyledLastPriceButton
      variant="text"
      onClick={() => {
        onHandleClick && onHandleClick(String(price))
      }}
    >
      <Tooltip
        title={'Fill in the current last price.'}
        enterDelay={400}
        placement="top"
        arrow
      >
        <span>Last</span>
      </Tooltip>
    </StyledLastPriceButton>
  )
})
